import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

interface StoreState {
  storeName: string;
  username: string;
  country: string;
  currency: string;
  address: string;
  taxId: string;
  taxIdLabel: string;
  branch_id: string;
  phone: string;
  storeEmail: string;
  logoUrl: string;
  logoPath: string;
  planName: string;
  printFormat: "58mm" | "80mm" | "A4";
  sequences: {
    factura: number;
    boleta: number;
    nota_credito_factura: number;
    nota_credito_boleta: number;
    remito: number;
    nota_venta: number;
    egreso: number;
  };
  series: {
    factura: string;
    boleta: string;
    nota_credito_factura: string;
    nota_credito_boleta: string;
    remito: string;
    nota_venta: string;
    egreso: string;
  };
  indecopi_libro_tipo: "fisico" | "virtual";
  indecopi_libro_url: string;
  indecopi_aviso_texto: string;
  digemid_codigo: string;
  digemid_director: string;
  sunat_user: string;
  sunat_pass: string;
  sunat_mode: "beta" | "production";
  cert_password: string;
  cert_path: string;
  sunat_validation_url: string;
  ubigueo: string;
  departamento: string;
  provincia: string;
  distrito: string;
  isOnboarded: boolean;
  userRole: string;
  userBranchName: string;
  setStoreInfo: (
    info: Partial<Omit<StoreState, "setStoreInfo" | "completeOnboarding" | "resetStore">>,
  ) => void;
  completeOnboarding: () => void;
  resetStore: () => void;
}

export const useAppStore = create<StoreState>()(
  persist(
    (set) => ({
      storeName: "",
      username: "",
      country: "",
      currency: "",
      address: "",
      taxId: "",
      taxIdLabel: "RUC",
      branch_id: "",
      phone: "",
      storeEmail: "",
      logoUrl: "",
      logoPath: "",
      planName: "Básico",
      printFormat: "80mm",
      sequences: {
        factura: 0,
        boleta: 0,
        nota_credito_factura: 0,
        nota_credito_boleta: 0,
        remito: 0,
        nota_venta: 0,
        egreso: 0,
      },
      series: {
        factura: "",
        boleta: "",
        nota_credito_factura: "",
        nota_credito_boleta: "",
        remito: "",
        nota_venta: "",
        egreso: "",
      },
      indecopi_libro_tipo: "fisico",
      indecopi_libro_url: "",
      indecopi_aviso_texto:
        "CONFORME A LO ESTABLECIDO EN EL CÓDIGO DE PROTECCIÓN Y DEFENSA DEL CONSUMIDOR, ESTA EMPRESA CUENTA CON UN LIBRO DE RECLAMACIONES A SU DISPOSICIÓN.",
      digemid_codigo: "",
      digemid_director: "",
      sunat_user: "",
      sunat_pass: "",
      sunat_mode: "beta",
      cert_password: "",
      cert_path: "",
      sunat_validation_url: "",
      ubigueo: "",
      departamento: "",
      provincia: "",
      distrito: "",
      isOnboarded: false,
      userRole: "",
      userBranchName: "",

      setStoreInfo: (info) => set((state) => ({ ...state, ...info })),

      completeOnboarding: () => set({ isOnboarded: true }),

      resetStore: () =>
        set({
          storeName: "",
          username: "",
          country: "",
          currency: "",
          address: "",
          taxId: "",
          taxIdLabel: "RUC",
          branch_id: "",
          phone: "",
          storeEmail: "",
          logoUrl: "",
          logoPath: "",
          planName: "Básico",
          printFormat: "80mm",
          sequences: {
            factura: 0,
            boleta: 0,
            nota_credito_factura: 0,
            nota_credito_boleta: 0,
            remito: 0,
            nota_venta: 0,
            egreso: 0,
          },
          series: {
            factura: "",
            boleta: "",
            nota_credito_factura: "",
            nota_credito_boleta: "",
            remito: "",
            nota_venta: "",
            egreso: "",
          },
          indecopi_libro_tipo: "fisico",
          indecopi_libro_url: "",
          indecopi_aviso_texto:
            "CONFORME A LO ESTABLECIDO EN EL CÓDIGO DE PROTECCIÓN Y DEFENSA DEL CONSUMIDOR, ESTA EMPRESA CUENTA UN LIBRO DE RECLAMACIONES A SU DISPOSICIÓN.",
          digemid_codigo: "",
          digemid_director: "",
          sunat_user: "",
          sunat_pass: "",
          sunat_mode: "beta",
          cert_password: "",
          cert_path: "",
          sunat_validation_url: "",
          ubigueo: "",
          departamento: "",
          provincia: "",
          distrito: "",
          isOnboarded: false,
          userRole: "",
          userBranchName: "",
        }),
    }),
    {
      name: "vitafarma-storage",
      storage: createJSONStorage(() => sessionStorage),
      partialize: (state) => {
        const rest = { ...state } as Record<string, unknown>;
        delete rest.sequences;
        delete rest.series;
        return rest;
      },
    },
  ),
);
